import React from 'react';
import './home.css';
import video from '../../Assests/video.mp4';
import { GrLocation } from 'react-icons/gr';
import {HiFilter} from 'react-icons/hi'
import {FiFacebook} from 'react-icons/fi'
import {AiOutlineInstagram} from 'react-icons/ai'
import {BsListTask} from 'react-icons/bs'
import {TbApps} from 'react-icons/tb'
import {SiTripadvisor} from 'react-icons/si'

const Home = () => {
  return (
    <section className='home'>
      {/* Overlay for the video */}
      <div className="overlay"></div>

      {/* Background video */}
      <video src={video} autoPlay loop muted type="video/mp4"></video>

      {/* Main content */}
      <div className="homeContent container">
        <div className="textDiv">
          <span className="smallText">Our Packages</span>
          <h1 className="homeTitle">Search your Holidays</h1>
        </div>

        {/* Input card */}
        <div className='cardDiv grid'>
          <div className="destinationInput">
            <label htmlFor="city">Search your destination:</label>
            <div className="input flex">
              <input type="text" placeholder='Enter name here...' id="city" />
              <GrLocation className="icon" />
            </div>
          </div>
          <div className="dateInput">
            <label htmlFor="date">Select your date</label>
            <div className="input flex">
              <input type="date"/>
            </div>
          </div>
          <div className="priceInput">
            <div className="label_total flex">
              <label htmlFor="price">Max price:</label>
              <h3 className="total">5000</h3>
            </div>
            <div className="input flex">
              <input type="range" max="5000" min="1000"/>
            </div>
          </div>
          <div className="searchOptions flex">
            <HiFilter className="icon"/>
            <span>More Filters</span>
          </div>
        </div>
        <div className="homeFooterIcons flex">
          <div className="rightIcons">
              <FiFacebook className="icon"/>
              <AiOutlineInstagram className="icon"/>
              <SiTripadvisor className="icon"/>
          </div>

          <div className='leftIcons'>
          <BsListTask className="icon"/>
          <TbApps className="icon"/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
